import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import "firebase/compat/storage";
import { connectFunctionsEmulator } from "firebase/functions";
const firebaseConfig = {
  apiKey: "AIzaSyAKLxIezOIW2pF3nIhZ-UI-TSAJMlQ-E3g",
  authDomain: "kit-wogehtwas.firebaseapp.com",
  projectId: "kit-wogehtwas",
  storageBucket: "kit-wogehtwas.firebasestorage.app",
  messagingSenderId: "33364506893",
  appId: "1:33364506893:web:cbde57f1af246afca01844"
};

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const FieldValue = firebase.firestore.FieldValue;
export const functions = firebase.functions();
export const GeoPoint = firebase.firestore.GeoPoint;
export const Timestamp = firebase.firestore.Timestamp;
export const storage = firebase.storage();